"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/** Function for components with local dictionaries
 * Allows to extend the global dictionary with a local dictionary of given component
 * @param i18n
 * @param componentName
 * @param dictionary
 */
var loadResources = function loadResources(i18n, componentName, dictionary) {
  var languageKeys = Object.keys(dictionary);
  languageKeys.forEach(function (languageKey) {
    // If the resource for this language has not been loaded
    // then load it
    if (!i18n.hasResourceBundle(languageKey, componentName)) {
      var resourceBundle = dictionary[languageKey];
      i18n.addResourceBundle(languageKey, componentName, resourceBundle, true, true);
    }
  });
};

var _default = loadResources;
exports["default"] = _default;
//# sourceMappingURL=loadResources.js.map